import React from 'react';
import * as Ons from 'react-onsenui';
import PullHook from '../PullHook';
import Toolbar from '../Toolbar';
import PlayerList from '../../containers/PlayerList';
import { expired } from '../../util';
import { translate as _ } from '../../util/i18n';
import { supports, wording } from '../../util/context';
import { POSITION_GOALKEEPER, SUSPENSION_SETTING_DENY } from '../../store/constants/misc';

class Eligibles extends React.Component {

    #goalkeeperLines;
    #pullHookCallback;
    #pullHookTimeout;

    constructor( props ) {

        super( props );

        this.state = {
            pullHook:              'initial',
            selectedLine:          null,
            selectedList:          0,
            selectedListType:      'Players',
            selectedPlayer:        null,
            selectedPlayers:       [],
            selectedTeamOfficials: []
        };

        this.handleLineSelect         = this.handleLineSelect.bind( this );
        this.handleLineSelectSubmit   = this.handleLineSelectSubmit.bind( this );
        this.handleListChange         = this.handleListChange.bind( this );
        this.handleLoadEligiblesClick = this.handleLoadEligiblesClick.bind( this );
        this.handleEligibleClick      = this.handleEligibleClick.bind( this );
        this.handlePullHookChange     = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad       = this.handlePullHookLoad.bind( this );
        this.handleSubmit             = this.handleSubmit.bind( this );

        this.#goalkeeperLines = [

            { line: 1, label: _( 'Start (Linie 1)'     ) },
            { line: 2, label: _( 'Backup (Linie 2)'    ) },
            { line: 3, label: _( 'Emergency (Linie 3)' ) },

        ];
    }

    componentDidMount() {

        expired( this.props.eligiblePlayers.lastUpdate ) && this.loadEligibles();

    }

    componentDidUpdate() {

        if ( this.#pullHookCallback ) {

            clearTimeout( this.#pullHookTimeout );

            const pullHookCallback = this.#pullHookCallback;
            this.#pullHookTimeout  = setTimeout( () => pullHookCallback(), 1000 );
            this.#pullHookCallback = null;

        }

    }

    handleLineSelect( selectedLine ) {

        this.setState( { selectedLine } )

    }

    handleLineSelectSubmit() {

        const selectedEligibles    = [ ...this.state[ 'selected' + this.state.selectedListType ] ];
        const index                = selectedEligibles.findIndex( e => e.id === this.state.selectedPlayer.id );
        const indexAlreadySelected = selectedEligibles.findIndex( e => e.position === POSITION_GOALKEEPER && e.selectedLine === this.state.selectedLine );

        if ( index !== -1 ) {

            selectedEligibles[ index ] = { ...selectedEligibles[ index ], selectedLine: this.state.selectedLine };

        }

        if ( indexAlreadySelected !== -1 ) {

            selectedEligibles.splice( indexAlreadySelected, 1 );

        }

        this.setState( { selectedPlayer: null, selectedLine: null, [ 'selected' + this.state.selectedListType ]: selectedEligibles } );

    }

    handleListChange( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // const selectedList     = Number( e.index );
        const selectedList     = Number( e.target.querySelector( 'input:checked' ).value );
        const selectedListType = selectedList < 2 ? 'Players' : 'TeamOfficials';

        this.setState( { selectedList, selectedListType } );

    }

    handleLoadEligiblesClick() {

        this.loadEligibles();

    }

    handleEligibleClick( eligible ) {

        if ( this.props.suspensionSetting === SUSPENSION_SETTING_DENY && eligible.isSuspended ) {

            return

        }

        const selectedEligibles = [ ...this.state[ 'selected' + this.state.selectedListType ] ];
        const index             = selectedEligibles.findIndex( e => e.id === eligible.id );
        const state             = {};

        if ( index === -1 ) {

            selectedEligibles.push( eligible );

            if ( eligible.position === POSITION_GOALKEEPER && this.props.simpleLineup ) {

                state.selectedLine   = null;
                state.selectedPlayer = eligible;

            }

        } else {

            selectedEligibles.splice( index, 1 );

        }

        state[ 'selected' + this.state.selectedListType ] = selectedEligibles;

        this.setState( state );

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

    }

    handlePullHookLoad( e ) {

        this.#pullHookCallback = e;

        this.loadEligibles();

    }

    handleSubmit() {

        this.props.onSubmit( this.state.selectedPlayers, this.state.selectedTeamOfficials );

    }

    loadEligibles() {

        this.props.onLoadEligiblePlayers( this.props.context, this.props.token, this.props.activeGame.id, this.props.teamId );

        supports( this.props.context, 'extendedRoster' ) && this.props.onLoadExtendedEligiblePlayers( this.props.context, this.props.token, this.props.activeGame.id, this.props.teamId );

        supports( this.props.context, 'teamOfficials' ) && this.props.onLoadEligibleTeamOfficials( this.props.context, this.props.token, this.props.activeGame.id, this.props.teamId );

        supports( this.props.context, 'extendedRoster' ) && supports( this.props.context, 'teamOfficials'  ) && this.props.onLoadExtendedEligibleTeamOfficials( this.props.context, this.props.token, this.props.activeGame.id, this.props.teamId );

    }

    render() {

        // console.log( 'components.Pages.Eligibles.render()', this.props, this.state );

        const eligiblesLists             = [ this.props.eligiblePlayers, this.props.extendedEligiblePlayers, this.props.eligibleTeamOfficials, this.props.extendedEligibleTeamOfficials ];
        const eligibles                  = eligiblesLists[ this.state.selectedList ];
        const selectedCount              = this.state.selectedPlayers.length + this.state.selectedTeamOfficials.length;
          let allGoalkeeperLinesInRoster = true;

        if ( this.props.simpleLineup ) {

            this.#goalkeeperLines = this.#goalkeeperLines.map( gkLine => {

                const alreadyInRoster = this.props.roster.find( player => player.lineupData.position === POSITION_GOALKEEPER && player.lineupData.line === gkLine.line );

                if ( ! alreadyInRoster ) {

                    allGoalkeeperLinesInRoster = false;

                }

                return {

                    ...gkLine, alreadyInRoster,

                    alreadySelected: this.state.selectedPlayers.find( selectedPlayer => selectedPlayer.position === POSITION_GOALKEEPER && selectedPlayer.selectedLine === gkLine.line ),

                }

            } )

        }

        return (

            <>

                <Ons.Page renderToolbar={() => <Toolbar onBackClick={this.props.onCancel} right={<Ons.ToolbarButton onClick={this.handleSubmit} disabled={selectedCount === 0}><Ons.Icon icon="fa-plus" /> {_( 'Hinzufügen' )} ({selectedCount})</Ons.ToolbarButton>} />}>

                    <PullHook onChange={this.handlePullHookChange} onLoad={this.handlePullHookLoad} />

                    {this.props.loading && this.state.pullHook !== 'action' && <Ons.ProgressBar indeterminate className="fixed-progress-bar" />}

                    <h1 className="page-title">{wording( this.props.context, 'lineup' ) ? _( 'Roster', 'singular' ) : _ ('Verfügbare Spieler' )}</h1>

                    <Ons.Card>

                        <p>

                            <Ons.Icon icon="fa-info-circle" />

                            &nbsp;

                            {_(

                                wording( this.props.context, 'lineup' ) ?

                                    ( supports( this.props.context, 'teamOfficials' ) ? 'Wähle Spieler und Team-Offizielle aus und füge sie zur Aufstellung hinzu.' : 'Wähle Spieler aus und füge sie zur Aufstellung hinzu.' )

                                :

                                ( supports( this.props.context, 'teamOfficials' ) ? 'Wähle Spieler und Team-Offizielle aus und füge sie zum Roster hinzu.' : 'Wähle Spieler aus und füge sie zum Roster hinzu.' )

                            )}

                            &nbsp;

                            {_( 'Anschließend kannst deren Daten ändern.' )}

                        </p>

                    </Ons.Card>

                    {( supports( this.props.context, 'extendedRoster' ) || supports( this.props.context, 'teamOfficials' ) ) &&

                        <div className="padded-page-content">

                            <Ons.Segment index={this.state.selectedList} onPostChange={this.handleListChange}>

                                <Ons.Button>{_( 'Roster', 'singular' )}</Ons.Button>

                                {supports( this.props.context, 'extendedRoster' ) && <Ons.Button>{_( 'Erw. Roster' )}</Ons.Button>}

                                {supports( this.props.context, 'teamOfficials' ) && <Ons.Button>{_( 'Offizielle' )}</Ons.Button>}

                                {supports( this.props.context, 'extendedRoster' ) && supports( this.props.context, 'teamOfficials' ) && <Ons.Button>{_( 'Erw. Offizielle' )}</Ons.Button>}

                            </Ons.Segment>

                        </div>

                    }

                    {
                        eligibles.items.length ?

                            <PlayerList
                                playerIsActive={eligible => this.state[ 'selected' + this.state.selectedListType ].find( selectedEligible => selectedEligible.id === eligible.id )}
                                onPlayerActivate={() => this.handleEligibleClick}
                                onPlayerClick={this.handleEligibleClick}
                                playersActivatable={eligible => this.props.suspensionSetting !== SUSPENSION_SETTING_DENY || ! eligible.isSuspended}
                                players={eligibles.items}
                                textActivatePlayer={_( this.state.selectedListType === 'TeamOfficials' ? 'Team-Offiziellen auswählen' : 'Spieler auswählen' )}
                                textPlayerIsActive={[ <i className="fa fa-check" key="0" />, <span key="1"> </span>, <span key="3">{_( this.state.selectedListType === 'TeamOfficials' ? 'Team-Offizieller ist ausgewählt' : 'Spieler ist ausgewählt' )}</span> ]}
                                type={this.state.selectedListType}
                            />

                        : ! expired( eligibles.lastUpdate ) &&

                            <div className="no-items">
                                <p>{_( this.state.selectedListType === 'TeamOfficials' ? 'Es stehen keine weiteren Team-Offiziellen zur Verfügung.' : 'Es stehen keine weiteren Spieler zur Verfügung.' )}</p>
                                <Ons.Button modifier="large" onClick={this.handleLoadEligiblesClick}>{_( 'Aktualisieren' )}</Ons.Button>
                            </div>
                    }

                </Ons.Page>

                {this.state.selectedPlayer !== null &&

                    <Ons.Dialog isOpen={this.state.selectedPlayer !== null} isCancelable={false}>

                        <div className="lineup-data-editor">

                            <h4>{_( 'Linie wählen' )}</h4>

                            <Ons.List
                                dataSource={this.#goalkeeperLines}
                                renderRow={( e, idx ) =>

                                    <Ons.ListItem key={e.line} modifier={idx === this.#goalkeeperLines.length - 1 ? 'longdivider' : null} tappable={! e.alreadyInRoster} onClick={e.alreadyInRoster ? null : () => this.handleLineSelect( e.line )}>

                                        <div className="left" style={{ minWidth: '36px' }}>

                                            {this.state.selectedLine === e.line && <Ons.Icon icon="fa-check" />}

                                        </div>

                                        <div className="center" style={{ opacity: e.alreadyInRoster ? .65 : 1 }}>

                                            <div style={{ width: '100%' }}>{e.label}</div>

                                            {e.alreadySelected && <div className="hint">{_( 'Bereits gewählt' )}: {e.alreadySelected.lastname} {e.alreadySelected.firstname} {e.alreadySelected.middlename} #{e.alreadySelected.jerseyNr}</div> }

                                            {e.alreadyInRoster && <div className="hint">{_( 'Bereits aufgestellt' )}: {e.alreadyInRoster.lastname} {e.alreadyInRoster.firstname} {e.alreadyInRoster.middlename} #{e.alreadyInRoster.jerseyNr}</div> }

                                        </div>

                                    </Ons.ListItem>
                                }
                            />

                            <div className="lineup-option">

                                <Ons.Button modifier="large" onClick={this.handleLineSelectSubmit} disabled={this.state.selectedLine === null && ! allGoalkeeperLinesInRoster}>{_( 'OK' )}</Ons.Button>

                            </div>

                        </div>

                    </Ons.Dialog>

                }

            </>

        );

    }

}

export default Eligibles;